<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="商品编码：">
            <el-input v-model="query.productCode" placeholder="请输入商品编码" clearable size="small" />
          </el-form-item>
          <el-form-item label="聚水潭编码：">
            <el-input v-model="query.skuCode" placeholder="请输入聚水潭编码" clearable size="small" />
          </el-form-item>
          <el-form-item label="商品名称：">
            <el-input v-model="query.name" placeholder="请输入商品名称" clearable size="small" />
          </el-form-item>
          <el-form-item label="状态：">
            <el-select v-model="query.state" placeholder="全部" clearable size="small">
              <el-option label="上架" :value="1" />
              <el-option label="下架" :value="0" />
            </el-select>
          </el-form-item>
          <el-form-item label="时间区域：" class="width100">
            <el-select v-model="timeType" placeholder="请选择" size="small" style="width:120px">
              <el-option label="创建时间" :value="1" />
              <el-option label="修改时间" :value="2" />
            </el-select>
            <el-date-picker v-model="dateTime" size="small" type="daterange" value-format="yyyy-MM-dd" start-placeholder="开始日期" end-placeholder="结束日期" style="width:320px" />
            <span class="hint">默认按创建时间筛选</span>
          </el-form-item>
          <el-form-item class="fr">
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <el-card class="box-card mt10">
      <div class="btn-right-side mb10">
        <div class="btn-box">
          <el-upload style="display:inline-block;margin-right:8px" :http-request="uploadFile" :show-file-list="false" accept=".xlsx,.xls">
            <el-button size="mini" type="primary" plain>导入</el-button>
          </el-upload>
          <el-button size="mini" type="primary" plain @click="handleTemplate" style="margin-right:8px">下载模板</el-button>
          <el-button type="primary" size="mini" @click="handleCreate" icon="el-icon-plus" v-hasPermi="['goods:outboundGoods:add']">新增商品</el-button>
          <el-button size="mini" type="primary" plain @click="handleBatchSync" v-hasPermi="['goods:outboundGoods:sync']">批量同步聚水潭{{ selectItems.length > 0 ? ' (' + selectItems.length + ')' : '' }}</el-button>
          <img src="../../../assets/Vector.png" class="vector" @click="handleChangeFields">
        </div>
      </div>

      <el-table v-loading="listLoading" :data="list" @selection-change="selectionChange" @sort-change="sortChange">
        <el-table-column type="selection" width="50" />
        <el-table-column :min-width="item.width" v-for="(item,index) in dynamicHeaders" :key="index" :prop="item.prop" :label="item.label" :sortable="item.isSortable" :show-overflow-tooltip="false">
          <template slot-scope="{row}">
            <span v-if="item.prop === 'name'" @click="handleShow(row)" style="color:#409EFF;cursor:pointer;text-overflow:clip;overflow:visible;white-space:normal;">{{ row.name }}</span>
            <template v-else-if="item.prop === 'img'">
              <el-image v-if="row.img" style="width:50px;height:50px" :src="row.img" :preview-src-list="[row.img]" />
              <span v-else>-</span>
            </template>
            <div v-else-if="item.prop === 'state'">
              <el-switch v-model="row.state" :active-value="1" :inactive-value="0" @change="changeSwitch(row)" />
              {{ row.state === 1 ? '上架' : '下架' }}
            </div>
            <span v-else-if="item.prop === 'createdTime' || item.prop === 'operatedTime' || item.prop === 'inventorySyncTime'">{{ formatTime(row[item.prop]) }}</span>
            <span v-else>{{ row[item.prop] }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="200" fixed="right">
          <template slot-scope="{row}">
            <el-button type="text" @click="handleUpdate(row)" v-hasPermi="['goods:outboundGoods:edit']">编辑</el-button>
            <el-button type="text" @click="handleSyncSingle(row)" v-hasPermi="['goods:outboundGoods:sync']">同步JST</el-button>
            <el-button type="text" style="color:red" @click="handleDeleteSingle(row)" v-hasPermi="['goods:outboundGoods:delete']">删除</el-button>
            <el-button type="text" @click="handleLog(row)">日志记录</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>

    <el-dialog :title="form.id?'编辑':'新增'" :visible.sync="formVisible" :close-on-click-modal="false" top="3vh" width="1000px">
      <div class="content" :style="'height:' + windowHeight + 'px;overflow-y:auto;'">
        <div class="reimbursement">
          <el-form ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="150px">
            <div class="title-box"><span class="txt1">商品基础信息</span></div>
            <el-form-item label="商品编码：" v-if="form.id">
              <el-input v-model="form.productCode" disabled />
            </el-form-item>
            <el-form-item label="聚水潭编码：" prop="skuCode">
              <div style="display:flex">
                <el-input v-model="form.skuCode" placeholder="请输入聚水潭编码" />
                <el-button type="primary" :loading="jstLoading" @click="getFromJST" style="margin-left:5px">获取数据</el-button>
              </div>
            </el-form-item>
            <el-form-item label="商品名称：" prop="name">
              <el-input v-model="form.name" placeholder="根据聚水潭编码自动读取" disabled />
            </el-form-item>
            <el-form-item label="曾用名：">
              <el-input v-model="form.usedName" placeholder="请输入曾用名" />
            </el-form-item>
            <el-form-item label="单位：">
              <el-input v-model="form.unit" placeholder="请输入单位" />
            </el-form-item>
            <el-form-item label="商品规格：">
              <el-input v-model="form.spec" placeholder="请输入商品规格(如:盒装/散装,100ml/200ml)" />
            </el-form-item>
            <el-form-item label="零售单价：" prop="price">
              <el-input v-model="form.price" placeholder="根据聚水潭编码自动读取" disabled />
            </el-form-item>
            <el-form-item label="库存：">
              <el-input v-model="form.inventory" placeholder="根据聚水潭编码自动读取" disabled />
            </el-form-item>
            <el-form-item label="供应商：">
              <el-input v-model="form.supplier" placeholder="根据聚水潭编码自动读取" disabled />
            </el-form-item>
            <el-form-item label="税收分类编码：">
              <el-input v-model="form.taxCode" placeholder="请输入税收分类编码" />
            </el-form-item>
            <el-form-item label="支持购买账户：" class="width100">
              <el-checkbox-group v-model="form.buyAccounts">
                <el-checkbox :label="1">余额</el-checkbox>
                <el-checkbox :label="2">零售价</el-checkbox>
                <el-checkbox :label="3">学费</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="商品主图：" class="width100">
              <image-upload v-model="form.img" width="32" height="32" />
              <span class="hint hint1">限制上传1张<br />建议尺寸750x750像素以上</span>
            </el-form-item>
            <el-form-item label="排序：">
              <el-input v-model="form.sort" placeholder="请输入排序" />
              <span>系统自动带出排序，并支持修改</span>
            </el-form-item>
            <el-form-item label="备注：">
              <el-input v-model="form.remark" type="textarea" :rows="2" placeholder="备注信息" />
            </el-form-item>
            <div class="title-box"><span class="txt1">权限</span></div>
                        <el-form-item label="购买权限：" class="width100" prop="customerLevelBuyList">
              <div class="lab" :class="{'active': item.isActive}" v-for="(item,idx) in buyLevelList" :key="'buy-'+idx" @click="item.isActive=!item.isActive">
                <i class="el-icon-success" v-if="item.isActive" />{{ item.name }}
              </div>
            </el-form-item>
            <div class="title-box"><span class="txt1">商品详情</span></div>
            <el-form-item label="商品详情：" class="width100">
              <editor v-model="form.detail" :min-height="240" :height="240" :uploadUrl="uploadUrl" />
            </el-form-item>
            <el-form-item label="状态：" class="width100">
              <el-switch v-model="form.state" :active-value="1" :inactive-value="0" />
              <span class="hint hint1">{{ form.state === 1 ? '上架' : '下架' }}</span>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="dialog-footer">
        <el-button @click="formVisible = false">取消</el-button>
        <el-button type="primary" :loading="isRepSub" :disabled="jstLoading" @click="doCreate()">确定</el-button>
      </div>
    </el-dialog>

    <change-fields-vue ref="fieldsPopup" :allTemplate="allTemplate" :cList="dynamicHeaders" @updated="doColumnList" />

    <!-- 导入进度弹窗 -->
    <el-dialog title="批量导入" :visible.sync="importVisible" width="500px" :close-on-click-modal="false">
      <div style="padding:10px">
        <div v-if="importDone">
          <el-alert :title="'导入完成！成功 '+importResult.success+' 条, 失败 '+importResult.fail+' 条, 跳过 '+importResult.skip+' 条'" type="success" :closable="false" show-icon style="margin-bottom:10px" />
          <div v-if="importResult.fail > 0 && importResult.failCodes && importResult.failCodes.length" style="max-height:200px;overflow-y:auto">
            <p style="color:#f56c6c;font-weight:bold">失败明细：</p>
            <p v-for="(code,idx) in importResult.failCodes" :key="idx" style="color:#f56c6c;margin:2px 0;font-size:13px">{{ code }}</p>
          </div>
        </div>
        <div v-else style="text-align:center;padding:20px">
          <el-progress :percentage="importProgress" />
          <p style="margin-top:15px;color:#666">正在导入...</p>
        </div>
      </div>
      <div slot="footer" v-if="importDone">
        <el-button type="primary" @click="importVisible = false; doQueryList({})">关闭</el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="showVisible" width="1000px" top="3vh" v-if="showData" class="detail-dialog">
      <div slot="title" class="detail-title">商品详情</div>
      <div class="title-box"><span class="txt1">基础信息</span></div>
      <el-descriptions :column="2" border style="margin-bottom:10px">
        <el-descriptions-item label="商品名称">{{ showData.name }}</el-descriptions-item>
        <el-descriptions-item label="商品编码">{{ showData.productCode || '-' }}</el-descriptions-item>
        <el-descriptions-item label="曾用名">{{ showData.usedName || '-' }}</el-descriptions-item>
        <el-descriptions-item label="聚水潭编码">{{ showData.skuCode }}</el-descriptions-item>
        <el-descriptions-item label="单位">{{ showData.unit || '-' }}</el-descriptions-item>
        <el-descriptions-item label="零售单价">{{ showData.price }}</el-descriptions-item>
        <el-descriptions-item label="库存">{{ showData.inventory || 0 }}</el-descriptions-item>
        <el-descriptions-item label="供应商">{{ showData.supplier || '-' }}</el-descriptions-item>
        <el-descriptions-item label="税收分类编码">{{ showData.taxCode || '-' }}</el-descriptions-item>
        <el-descriptions-item label="支持购买账户">{{ showAccountLabel(showData.buyAccounts) }}</el-descriptions-item>
        <el-descriptions-item label="购买权限">{{ showRoleLabel(showData.visibleRoles) }}</el-descriptions-item>
        <el-descriptions-item label="备注">{{ showData.remark || '-' }}</el-descriptions-item>
        <el-descriptions-item label="排序">{{ showData.sort }}</el-descriptions-item>
        <el-descriptions-item label="状态">{{ showData.state === 1 ? '上架' : '下架' }}</el-descriptions-item>
        <el-descriptions-item label="创建人">{{ showData.createdBy || '-' }}</el-descriptions-item>
        <el-descriptions-item label="创建时间">{{ formatTime(showData.createdTime) }}</el-descriptions-item>
        <el-descriptions-item label="最近修改时间">{{ formatTime(showData.operatedTime) }}</el-descriptions-item>
        <el-descriptions-item label="库存同步时间">{{ formatTime(showData.inventorySyncTime) }}</el-descriptions-item>
      </el-descriptions>
      <div class="title-box"><span class="txt1">商品详情</span></div>
      <div v-if="showData.detail" style="padding:10px 0;line-height:1.8" v-html="showData.detail" />
      <div v-else style="padding:10px 0;color:#999">暂无商品详情</div>
      <div class="title-box"><span class="txt1">商品主图</span></div>
      <div style="text-align:center;padding:10px">
        <el-image v-if="showData.img" style="width:120px;height:120px" :src="showData.img" :preview-src-list="[showData.img]" />
        <span v-else>-</span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getGoodsPage, getGoodsDetail, addGoods, updateGoods, deleteGoods, updateGoodsState, syncGoodsInventory, syncGoodsInfo, downloadGoodsTemplate } from '@/api/order/outboundOrder'
import sysGoodsApi from '@/api/goods/sysGoods'
import customerLevelApi from '@/api/sys/customerLevel'
import Pagination from '@/components/Pagination'
import ImageUpload from '@/components/ImageUpload'
import Editor from '@/components/Editor'
import request from '@/utils/request'
import changeFieldsVue from '@/views/common/changeFields.vue'

export default {
  name: 'OutboundGoods',
  components: { Pagination, ImageUpload, Editor, changeFieldsVue },
  data() {
    return {
      list: [], total: 0, listLoading: false,
      query: { pageNo: 1, pageSize: 10, productCode: undefined, skuCode: undefined, name: undefined, state: undefined },
      selectItems: [], dateTime: [], timeType: 1,
      allTemplate: [
        { label: '商品名称', prop: 'name', width: 300 },
        { label: '商品编码', prop: 'productCode', width: 140 },
        { label: '聚水潭编码', prop: 'skuCode', width: 150 },
        { label: '曾用名', prop: 'usedName', width: 150 }, { label: '商品主图', prop: 'img', width: 80 },
        { label: '单位', prop: 'unit', width: 60 }, { label: '规格', prop: 'spec', width: 100 }, { label: '零售单价', prop: 'price', width: 100 },
        { label: '库存', prop: 'inventory', width: 80 },
        { label: '创建时间', prop: 'createdTime', width: 160, isSortable: 'custom' },
        { label: '最近修改时间', prop: 'operatedTime', width: 160, isSortable: 'custom' },
        { label: '状态', prop: 'state', width: 100 }
      ],
      dynamicHeaders: [],
      formVisible: false, windowHeight: 500, isRepSub: false, isGetYou: false, jstLoading: false,
      importVisible: false, importProgress: 0, importDone: false, importResult: {},
      showVisible: false, showData: null, levelList: [], buyLevelList: [],
      uploadUrl: process.env.VUE_APP_BASE_API + '/sys/cosUploader/upload',
      form: this.initFormBean(),
      formRules: {
        skuCode: [{ required: true, message: '请输入聚水潭编码', trigger: 'blur' }],
        name: [{ required: true, message: '请输入商品名称', trigger: 'blur' }],
        price: [{ required: true, message: '请输入零售单价', trigger: 'blur' },
          { pattern: /^\d+(\.\d{1,2})?$/, message: '必须为数字值', trigger: 'blur' }]
      }
    }
  },
  created() {
    this.windowHeight = window.innerHeight - 200
    this.doQueryList({ pageNo: 1 })
    this.getFieled()
    this.loadBuyLevels()
  },
  methods: {
    initFormBean() {
      return {
        id: undefined, name: '', usedName: '', skuCode: '', productCode: '', unit: '', spec: '', price: '', inventory: 0,
        img: '', sort: '', remark: '', detail: '', state: 1,
        supplier: '', taxCode: '', buyAccounts: [1, 2, 3]
      }
    },
    loadBuyLevels() {
      customerLevelApi.fetchList({ levelSortSign: -1 }).then(({ data }) => {
        this.buyLevelList = data.filter(item => [3,4,5,6,7].includes(item.id))
          .map(item => ({ id: item.id, name: item.name, isActive: false }))
      })
    },
    getFieled() { this.dynamicHeaders = this.allTemplate },
    doColumnList(checkedList) {
      if (!checkedList || !checkedList.length) return
      this.dynamicHeaders = this.allTemplate.filter(item => checkedList.indexOf(item.prop) > -1)
    },
    handleChangeFields() { this.$refs.fieldsPopup.open() },
    async getFromJST() {
      const { skuCode } = this.form
      if (!skuCode) return this.$message.error('请输入聚水潭编码')
      this.jstLoading = true
      try {
        const [goodsRes, inventoryRes] = await Promise.all([
          sysGoodsApi.getGoodsByYongYouCode({ codes: skuCode }),
          sysGoodsApi.getGoodsQuantityByYongYouCode({ codes: skuCode })
        ])
        const goodsData = goodsRes.data || []
        const goodsList = typeof goodsData === 'string' ? JSON.parse(goodsData) : goodsData
        if (goodsRes.code !== '0' || !goodsList.length) return this.$message.warning('聚水潭未查询到该商品')
        const goods = goodsList[0]
        this.form.name = goods.name || ''
        this.form.price = goods.sale_price === null || goods.sale_price === undefined ? '' : goods.sale_price
        this.form.unit = goods.unit || ''
        this.form.supplier = goods.supplier_name || ''
        if (inventoryRes.code === '0') {
          const inventoryList = inventoryRes.data || []
          const inventory = inventoryList.length ? inventoryList[0] : {}
          const warehouseInventory = inventory.customize_qty_1 === null || inventory.customize_qty_1 === undefined
            ? (inventory.qty || 0)
            : inventory.customize_qty_1
          this.form.inventory = Number(warehouseInventory)
        }
        this.isGetYou = true
        this.$message.success('聚水潭数据获取成功')
      } finally {
        this.jstLoading = false
      }
    },
    selectionChange(val) { this.selectItems = val },
    sortChange({ prop, order }) {
      const sign = order === 'ascending' ? 1 : (order === 'descending' ? -1 : null)
      this.query.createdTimeSortSign = prop === 'createdTime' ? sign : null
      this.query.operatedTimeSortSign = prop === 'operatedTime' ? sign : null
      this.doQueryList({})
    },
    handleQuery() { this.doQueryList({ pageNo: 1 }) },
    handleFilter() {
      this.query = { pageNo: 1, pageSize: 10, productCode: undefined, skuCode: undefined, name: undefined, state: undefined }
      this.timeType = 1; this.dateTime = []; this.doQueryList({ pageNo: 1 })
    },
    calcQuery() {
      delete this.query.startTime; delete this.query.endTime; delete this.query.timeType
      if (this.dateTime && this.dateTime.length > 0) {
        this.query.startTime = this.dateTime[0] + ' 00:00:00'; this.query.endTime = this.dateTime[1] + ' 23:59:59'
      }
      // 时间类型固定有值(默认创建时间),避免出现"只选日期不知道按哪个时间筛"的歧义
      this.query.timeType = this.timeType || 1
    },
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) this.query.pageNo = pageNo
      if (pageSize) this.query.pageSize = pageSize
      this.calcQuery(); this.listLoading = true
      return getGoodsPage(this.query).then(res => {
        if (res.code === '0') { this.list = res.data.list; this.total = res.data.total }
      }).finally(() => { this.listLoading = false })
    },
    changeSwitch(row) {
      updateGoodsState(row.id, row.state).then(() => { this.$message.success('操作成功'); this.doQueryList({}) })
    },
    handleCreate() {
      this.resetForm()
      this.buyLevelList.forEach(item => { item.isActive = false })
      this.formVisible = true
    },
    handleUpdate(row) {
      this.resetForm()
      this.isGetYou = true
      this.form.id = row.id
      this.form.name = row.name
      this.form.productCode = row.productCode || ''
      this.form.usedName = row.usedName
      this.form.skuCode = row.skuCode
      this.form.img = row.img
      this.form.unit = row.unit
      this.form.spec = row.spec || ''
      this.form.price = row.price
      this.form.inventory = row.inventory
      this.form.state = row.state
      this.form.remark = row.remark
      this.form.sort = row.sort
      this.form.supplier = row.supplier
      this.form.taxCode = row.taxCode
      this.form.detail = row.detail
      this.form.visibleRoles = row.visibleRoles
      const selectedIds = (row.visibleRoles || '').split(',').filter(Boolean)
      this.buyLevelList.forEach(item => { item.isActive = selectedIds.indexOf(String(item.id)) > -1 })
      this.form.buyAccounts = (row.buyAccounts || '').split(',').filter(Boolean).map(Number)
      if (!this.form.buyAccounts.length) this.form.buyAccounts = [1, 2, 3]
      this.formVisible = true
    },
    formatTime(val) {
      if (!val) return '-'
      return val.replace('T', ' ')
    },
    handleShow(row) {
      getGoodsDetail(row.id).then(res => {
        if (res.code === '0') {
          this.showData = res.data
          // 翻译创建人
          if (this.showData.createdBy) {
            request({ url: '/sys/user/' + this.showData.createdBy, method: 'get' }).then(r => {
              if (r.code === '0') { this.showData.createdBy = r.data.realName || r.data.userName || this.showData.createdBy }
            }).catch(() => {})
          }
          this.showVisible = true
        }
      })
      if (!this.levelList.length) {
        customerLevelApi.fetchList({ levelSortSign: -1 }).then(({ data }) => { this.levelList = data })
      }
    },
    showAccountLabel(val) {
      if (!val) return '-'
      const m = { '1': '余额', '2': '零售价', '3': '学费' }
      return val.split(',').map(v => m[v] || v).join('、')
    },
    showRoleLabel(val) {
      if (!val || !this.levelList.length) return val || '-'
      return val.split(',').map(v => { const lv = this.levelList.find(l => l.id == v); return lv ? lv.name : v }).join('、')
    },
    handleLog(row) { this.$router.push('/log/log?type=101&id=' + row.id) },
    resetForm() { this.form = this.initFormBean(); this.isGetYou = false },
    doCreate() {
      if (this.jstLoading) return this.$message.warning('请等待聚水潭数据获取完成')
      this.$refs.dataForm.validate(valid => {
        if (!valid) return
        if (this.isRepSub) return
        let params = { ...this.form }
        // 校验购买权限
        const activeLevels = this.buyLevelList.filter(item => item.isActive).map(item => String(item.id))
        if (!activeLevels.length) return this.$message.error('请选择购买权限')
        params.price = params.price ? parseFloat(params.price) : 0
        params.sort = params.sort ? parseInt(params.sort) : 0
        params.inventory = parseInt(params.inventory) || 0
        params.visibleRoles = activeLevels.join(',')
        params.buyAccounts = params.buyAccounts && params.buyAccounts.length > 0 ? params.buyAccounts.join(',') : ''
        this.isRepSub = true
        const api = params.id ? updateGoods(params) : addGoods(params)
        api.then(() => {
          this.isRepSub = false; this.$message.success('操作成功')
          this.formVisible = false
          return this.doQueryList({})
        }).catch(() => { this.isRepSub = false })
      })
    },
    handleDeleteSingle(row) {
      this.$confirm('是否确认删除', '提示', { type: 'warning' }).then(() => {
        deleteGoods(row.id).then(() => { this.$message.success('删除成功'); this.doQueryList({ pageNo: 1 }) })
      }).catch(() => {})
    },
    handleBatchSync() {
      if (this.selectItems.length <= 0) { this.$message.warning('请选择商品'); return }
      const codes = this.selectItems.map(r => r.skuCode)
      this.$confirm('确认批量同步聚水潭吗（库存+信息）', '提示').then(() => {
        syncGoodsInventory(codes).then(() => {
          syncGoodsInfo(codes).then(res => {
            if (res.code === '0') { this.$message.success(res.data || '同步成功'); this.doQueryList({ pageNo: 1 }) }
          })
        })
      }).catch(() => {})
    },
    handleSyncSingle(row) {
      this.$confirm('确认同步该商品吗（库存+信息）', '提示').then(() => {
        syncGoodsInventory([row.skuCode]).then(() => {
          syncGoodsInfo([row.skuCode]).then(res => {
            if (res.code === '0') { this.$message.success(res.data || '同步成功'); this.doQueryList({ pageNo: 1 }) }
          })
        })
      }).catch(() => {})
    },
    uploadFile(file) {
      this.importVisible = true; this.importDone = false; this.importProgress = 0; this.importResult = {}
      let formData = new FormData(); formData.append('file', file.file)
      request({ url: '/outbound/goods/import', method: 'post', data: formData, headers: { 'Content-Type': 'multipart/form-data' }, onUploadProgress: e => {
        if (e.total > 0) this.importProgress = 30 + Math.floor(e.loaded / e.total * 30)
      } }).then(res => {
        if (res.code === '0') {
          this.importProgress = 100; this.importDone = true; this.importResult = res.data
        } else {
          this.importDone = true; this.importResult = { success: 0, fail: 1, skip: 0, failCodes: [res.msg || '导入失败'] }
        }
      }).catch(() => {
        this.importDone = true; this.importResult = { success: 0, fail: 1, skip: 0, failCodes: ['网络错误'] }
      })
    },
    handleTemplate() {
      downloadGoodsTemplate()
    }
  }
}
</script>

<style lang="scss" scoped>
.mt10 { margin-top: 10px; }
.dialog-footer { position: absolute; bottom: 5px; text-align: right; right: 20px; }
::v-deep .el-dialog__body { padding: 10px 0; }
.reimbursement { padding-bottom: 40px; }
.title-box {
  margin-bottom: 10px; margin-right: 24px;
  &::after { content: ''; display: table; clear: both; }
  .txt1 {
    font-size: 16px; color: #000000; position: relative; padding-left: 30px;
    &::before { content: ''; position: absolute; left: 20px; top: 3px; bottom: 0; width: 4px; background: #5dbde7; border-radius: 6px; }
  }
}
.el-form-item--small.el-form-item { width: 48%; display: inline-block; vertical-align: top; }
.el-form-item--small.el-form-item.width100 { width: 97%; }
::v-deep .el-select { width: 100%; }
::v-deep .el-cascader { width: 100%; }
::v-deep .el-checkbox { margin-right: 10px; }
.hint { font-size: 12px; color: #878787; &.hint1 { padding-left: 10px; line-height: 18px; } }
::v-deep .el-table__body-wrapper .el-table__body .cell {
  text-overflow: clip;
}
.vector { width: 25px; height: 25px; vertical-align: middle; margin-left: 10px; }
.detail-dialog ::v-deep .el-descriptions__label { font-size: 14px; }
.detail-dialog ::v-deep .el-descriptions__content { font-size: 14px; }
.detail-title { font-size: 18px; color: #303133; }
.lab {
  font-size: 14px; color: #8f8e8e; border-radius: 4px; padding: 0 18px;
  display: inline-block; border: 1px solid #c5c5c5; margin: 5px; position: relative; cursor: pointer;
  &.active { background: #5dbde7; color: #fff; border-color: #5dbde7; }
  i { position: absolute; left: 0; top: 0; }
}
</style>
